const MAKE_CONTRACT_ORDER_SCHEMA = schema.object({
  nickname: schema
    .string({
      invalid_type_error: localeValidation().required,
      required_error: localeValidation().required,
    })
    .min(1, {
      message: localeValidation().required,
    }),
  name: schema
    .string({
      invalid_type_error: localeValidation().required,
      required_error: localeValidation().required,
    })
    .min(1, {
      message: localeValidation().required,
    }),
  phone: schema
    .string({
      required_error: localeValidation().required,
    })
    .refine(
      (value) => {
        if (!value) return false;

        const digits = value.replaceAll(/\D/g, "");

        if (digits.length <= 4) return true;

        const phoneRegex = /^\+\d{7,15}$/;

        return phoneRegex.test(value.replaceAll(/\s+/g, ""));
      },
      {
        message: localeValidation().invalidPhone,
      },
    ),
  question: schema
    .string({
      invalid_type_error: localeValidation().required,
      required_error: localeValidation().required,
    })
    .min(1, {
      message: localeValidation().required,
    }),
  type: schema.string().optional(),
});

type MakeContractOrderFields = FormFields<MakeContractOrderSchemaInfer>;

type MakeContractOrderForm = MakeContactOrderMutationVariables;

type MakeContractOrderSchemaInfer = SchemaInfer<typeof MAKE_CONTRACT_ORDER_SCHEMA>;

export { MAKE_CONTRACT_ORDER_SCHEMA };
export type { MakeContractOrderFields, MakeContractOrderForm };
